exports = module.exports = require("../../../graylog2-server/graylog2-web-interface/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._35Zz0rmxs3etQE3_IPh6nk dt:after{content:\":\"}.aYZiJQq05XgB5mA4YDVLo dt:after{content:\"\"}.auditlog-status dl{margin-top:8px}", ""]);

// exports
exports.locals = {
	"descriptionList": "_35Zz0rmxs3etQE3_IPh6nk",
	"innerDl": "aYZiJQq05XgB5mA4YDVLo"
};


//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/node_modules/css-loader!./src/web/AuditLogStatus.css
// module id = 548
// module chunks = 0